import React from 'react';

import { Money, formatMoney } from '@betterment/js-runtime';
import { HStack, Text, VStack } from '@betterment/samba-react';

import { TaxLossHarvestingSetupLink } from './Links';
import { TaxLossHarvestingTooltip } from './TaxLossHarvestingTooltip';

import { TaxLossHarvestingPerformanceModal } from '../../tax-loss-harvesting-performance-modal/TaxLossHarvestingPerformanceModal';

type Props = {
  taxLossesHarvested?: Money | null;
  allTimeEstimatedTaxSavings?: Money | null;
};

export const TaxLossHarvestingRow: React.FC<Props> = ({ taxLossesHarvested, allTimeEstimatedTaxSavings }) => {
  if (!taxLossesHarvested) {
    return (
      <HStack css={{ justifyContent: 'space-between' }}>
        <HStack>
          <Text>Tax loss harvesting</Text>
          <TaxLossHarvestingTooltip isEnabled={false} />
        </HStack>
        <TaxLossHarvestingSetupLink />
      </HStack>
    );
  }

  if (taxLossesHarvested.cents === 0) {
    return (
      <HStack css={{ justifyContent: 'space-between' }}>
        <HStack>
          <Text>Tax loss harvesting</Text>
          <TaxLossHarvestingTooltip isEnabled={true} />
        </HStack>
        <Text>Active</Text>
      </HStack>
    );
  }

  if (allTimeEstimatedTaxSavings) {
    return (
      <HStack css={{ justifyContent: 'space-between' }}>
        <VStack>
          <Text>Estimated tax savings</Text>
          <TaxLossHarvestingPerformanceModal />
        </VStack>
        <Text css={{ pl: 'space.300', fontVariantNumeric: 'tabular-nums' }}>
          {formatMoney(allTimeEstimatedTaxSavings)}
        </Text>
      </HStack>
    );
  }

  return null;
};
